import React, { useEffect, useState } from 'react';

import styles from './b2b-access-hero.module.scss';
import Image from 'next/image';
import classNames from 'classnames';
import { B2BCategory } from '../b2b-category/b2b-category';

import { Article } from '@/types/Article';
import { Locale, replaceOrAddLocale, useLocale } from '@/helpers/LangHelper';
import Link from 'next/link';
import { getLatestArticles } from '@/helpers/BuilderHelper';
import BusinessButton from '@/components/business-button/business-button';
import { COLORS } from '@/components/business-button/business-button.constants';

export interface Props {
    article?: Article;
}

const B2BAccessHero = (props: Props) => {
    const [article, setArticle] = useState(props.article);
    const { locale } = useLocale();
    const categories = article?.categories || [];

    const getLatestArticle = async () => {
        const articles = await getLatestArticles({ locale, offset: 0, limit: 1 });
        if (articles?.[0]) {
            setArticle(articles?.[0]);
        }
    };

    useEffect(() => {
        if (props.article) return;
        getLatestArticle();
    }, [props.article]);

    return (
        <div className={classNames(styles.container)}>
            <div className={styles.background}>
                <div className={styles.image}>
                    {article?.leadImage && (
                        <Image
                            className={classNames({ [styles.desktop]: !!article?.leadPortraitImage })}
                            src={article?.leadImage}
                            alt=""
                            loading={'lazy'}
                            fill
                            style={{ objectFit: 'cover', objectPosition: 'center' }}
                            loader={({ src, width, quality }) => {
                                return `${src}?width=${width}&quality=${quality ?? 75}`;
                            }}
                        />
                    )}
                    {article?.leadPortraitImage && (
                        <Image
                            className={classNames({ [styles.mobile]: !!article?.leadImage })}
                            src={article.leadPortraitImage}
                            alt=""
                            loading={'lazy'}
                            fill
                            style={{ objectFit: 'cover', objectPosition: 'center' }}
                            loader={({ src, width, quality }) => {
                                return `${src}?width=${width}&quality=${quality ?? 75}`;
                            }}
                        />
                    )}
                </div>
            </div>
            <div className={styles.content}>
                {categories.length ? <B2BCategory categories={categories} className={styles.categories} theme="light" /> : null}
                {article?.title ? <div className={classNames(styles.title)} dangerouslySetInnerHTML={{ __html: article?.title }} /> : null}
                {article?.description ? <div className={styles.description} dangerouslySetInnerHTML={{ __html: article.description }} /> : null}

                {article?.articleUrl ? (
                    <BusinessButton link={replaceOrAddLocale(article?.articleUrl, Locale.USA)} buttonText="Read More" target="_self" autoMargin={false} color={COLORS.WHITE} />
                ) : null}
            </div>
        </div>
    );
};

export default B2BAccessHero;
